export const TEST_TYPE = 'TEST_TYPE';
export const RUNS_FETCHED = 'RUNS_FETCHED';
export const PUT_RUN_TO_STATE = 'PUT_RUN_TO_STATE';
export const PUT_USER_TO_STATE = 'PUT_USER_TO_STATE';
export const GET_RUN_SUCCESS = 'GET_RUN_SUCCESS';

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
export const GET_CONFLICTS_SUCCESS = 'GET_CONFLICTS_SUCCESS';

export const GET_REQUIREMENTS_SUCCESS = 'GET_REQUIREMENTS_SUCCESS';

export const GET_DEANS_SUCCESS = 'GET_DEANS_SUCCESS';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const GET_CROSSLIST_SUCCESS = 'GET_CROSSLIST_SUCCESS';
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS';
export const GET_STUDENT_BY_ID_SUCCESS = 'GET_STUDENT_BY_ID_SUCCESS';
export const GET_COURSE_BY_ID_SUCCESS = 'GET_COURSE_BY_ID_SUCCESS';

export const GET_All_GROUPS_SUCCESS = 'GET_All_GROUPS_SUCCESS';

export const GET_GROUP_BY_ID_SUCCESS = 'GET_GROUP_BY_ID_SUCCESS';
export const GET_ALL_GROUP_LOCKS_SUCCESS = 'GET_ALL_GROUP_LOCKS_SUCCESS';
export const GET_ALL_GROUP_CONFLICTS_SUCCESS = 'GET_ALL_GROUP_CONFLICTS_SUCCESS';
export const GET_ALL_GROUP_REQUIREMENTS_SUCCESS = 'GET_ALL_GROUP_REQUIREMENTS_SUCCESS';
export const GET_ALL_STUDENT_LOCKS_SUCCESS = 'GET_ALL_STUDENT_LOCKS_SUCCESS';
export const GET_ALL_STUDENT_CONFLICTS_SUCCESS = 'GET_ALL_STUDENT_CONFLICTS_SUCCESS';
export const GET_ALL_STUDENT_REQUIREMENTS_SUCCESS = 'GET_ALL_STUDENT_REQUIREMENTS_SUCCESS';
export const GET_ALL_STUDENT_RESTRICTIONS = 'GET_ALL_STUDENT_RESTRICTIONS';
export const GET_ALL_STUDENT_OVERRIDES = 'GET_ALL_STUDENT_OVERRIDES';
export const GET_ALL_STUDENT_COURSES_PREFERENCE_SUCCESS = 'GET_ALL_STUDENT_COURSES_PREFERENCE_SUCCESS';
export const PUT_STUDENTS_COURSES_TO_STATE = 'PUT_STUDENTS_COURSES_TO_STATE';
export const GET_ALL_RANK_PREFERENCES_SUCCESS = 'GET_ALL_RANK_PREFERENCES_SUCCESS';
export const GET_LINKS_SUCCESS = 'GET_LINKS_SUCCESS';
export const GET_TOPK_SUCCESS = 'GET_TOPK_SUCCESS';
export const GET_ALLOCATIONS_SUCCESS = 'GET_ALLOCATIONS_SUCCESS';

export const GET_SCHOOL_BY_ID_SUCCESS = 'GET_SCHOOL_BY_ID_SUCCESS';
export const GET_FINISHED_COMPUTATIONS_SUCCESS = 'GET_FINISHED_COMPUTATIONS_SUCCESS';

export const GET_ASSIGNMENTS_SUCCESS = 'GET_ASSIGNMENTS_SUCCESS';
export const GET_WAITLIST_START = 'GET_WAITLIST_START';
export const GET_WAITLIST_SUCCESS = 'GET_WAITLIST_SUSSESS';
export const DELETE_WAITLIST_SUCCESS = 'DELETE_WAITLIST_SUSSESS';
export const UPDATE_WAITLIST = 'UPDATE_WAITLIST'
export const ADD_WAITLIST_SUCCESS = 'ADD_WAITLIST_SUCCESS'
export const ASSIGNMENTS_UPDATE_ENTITY = 'ASSIGNMENTS_UPDATE_ENTITY';
export const ASSIGNMENTS_DELETE_ENTITY = 'ASSIGNMENTS_DELETE_ENTITY';
export const ASSIGNMENTS_DROP = 'ASSIGNMENTS_DROP';
// export const CREATE_ADD_SUCCESS = 'CREATE_ADD_SUCCESS';
export const GET_COURSE_RANKINGS_SUCCESS = 'GET_COURSE_RANKINGS_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/types.js